
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|1795|4901|7867)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
